import s from './style.module.scss';
import { Spin } from 'antd';
import { CloseOutline, LeftOutline } from 'antd-mobile-icons';
import { Display } from '@/components/Display/Display';
import MindMap from '@/components/MindMap';
import { useState } from 'react';
import GrtButton from '@/components/Mobile/GrtButton';
import { Mask } from 'antd-mobile';

let defaulDetail = {
    resource_name: '',
    template_ids: [],
    template_names: [],
    keywords: [],
    mind_map_summary_list: [],
    paragraph_summary: ''
};

const CourseDetail = (props) => {
    const { clickLearn, onClose, returnAllList, detail = defaulDetail, allLen = 0 } = props;

    const [loading, setLoading] = useState(false);

    const [mindOpen, setMindOpen] = useState(false);
    //思维导图打开
    const onMindOpen = () => {
        setMindOpen(true);
    };

    const handleClickLearn = () => {
        clickLearn(detail.resource_id);
    };
    return (
        <div className={[`${s['modal-box']} ${s['course-detail-box']}`]}>
            <Mask visible={mindOpen} onMaskClick={() => setMindOpen(false)}>
                <div className={s['mask-mind-wrap']}>
                    <div className={s['title']}>
                        <span
                            onClick={() => {
                                setMindOpen(false);
                            }}
                        >
                            <CloseOutline />
                        </span>
                    </div>
                    <MindMap
                        mindMapSummaryListData={detail?.mind_map_summary_list}
                        // width={window.innerWidth}
                        height={window.innerHeight * 0.7}
                        courseName={detail?.resource_name}
                    ></MindMap>
                </div>
            </Mask>
            <div className={s['all-title']}>
                <div className={s['left']}>视频详情</div>
                <span onClick={onClose}>
                    <CloseOutline />
                </span>
            </div>
            <Display show={loading}>
                <div style={{ height: 200, display: 'flex', justifyContent: 'center' }}>
                    <Spin spinning={true}></Spin>
                </div>
            </Display>
            <Display show={!loading}>
                <div className={s['content-wrap']}>
                    <Display show={allLen > 2}>
                        <div onClick={returnAllList} className={s['return-div']}>
                            <LeftOutline />
                            <span> 返回视频列表</span>
                        </div>
                    </Display>

                    <div className={s['course-title']}>{detail?.resource_name}</div>
                    <div className={s['business-type']}>所属业务：{detail?.template_names?.join('、')}</div>
                    <div className={s['scroll-box']}>
                        <Display show={detail?.keywords && detail?.keywords.length}>
                            <>
                                <div className={s['type-title']}>关键词</div>
                                <div className={s['key-word']}>
                                    {detail?.keywords.map((ele, index) => {
                                        return <span key={index}>{ele}</span>;
                                    })}
                                </div>
                            </>
                        </Display>
                        <Display show={detail?.paragraph_summary}>
                            <>
                                <div className={s['type-title']}>视频摘要</div>
                                <div className={s['summary']}>{detail?.paragraph_summary}</div>
                            </>
                        </Display>
                        <Display show={detail?.mind_map_summary_list && detail?.mind_map_summary_list.length}>
                            <>
                                <div className={s['type-title']}>思维导图</div>
                                <div className={s['mind-wrap']} onClick={onMindOpen}>
                                    <div className={s['mask']}></div>
                                    <MindMap
                                        mindMapSummaryListData={detail?.mind_map_summary_list}
                                        width={380}
                                        courseName={detail?.resource_name}
                                    ></MindMap>
                                </div>
                            </>
                        </Display>
                    </div>
                    <div className={s['footer-wrap']}>
                        <GrtButton className={s['button']} color="primary" onClick={handleClickLearn}>
                            立即学习
                        </GrtButton>
                    </div>
                </div>
            </Display>
        </div>
    );
};

export default CourseDetail;
